import $ from 'jquery';
import moment from 'app/lib/moment/moment-99designs';

var momentLoader = {
    getConfig: function($span) {
        var format = 'relative';

        if ($span.hasClass('timestamp')) {
            format = 'LLL'; // moment.js locale specific datetime

            if ($span.hasClass('abbr') || $span.hasClass('notime')) {
                format = 'LL'; // moment.js locale specific date
            }
        }

        if ($span.hasClass('shortabs')) {
            format = 'LT L';
        }

        if ($span.hasClass('timeonly')) {
            format = 'LT'; // moment.js locale specific time
        }

        return {
            format: format,
            shortFormat: $span.hasClass('shortFormat'),
            print: $span.hasClass('printable'),
            describe: $span.hasClass('descr'),
            title: !$span.hasClass('notitle') || $span.hasClass('withTitle'),
        };
    },

    getGtmTime: function($span) {
        if ($span.attr('data-gmttime')) {
            return $span.attr('data-gmttime');
        } else {
            // legacy approach
            return $span.text();
        }
    },

    processSpan: function(node) {
        if (node.gmttime) {
            return;
        }

        const span = $(node);
        const config = momentLoader.getConfig(span);
        const date = moment(momentLoader.getGtmTime(span));

        if (config.format === 'relative') {
            span.html(
                '<span class="screen">' +
                    date.fromNow(!config.describe, config.shortFormat) +
                    '</span>'
            );
        } else {
            span.html('<span class="screen">' + date.format(config.format) + '</span>');
        }

        if (config.print) {
            span.append('<span class="print">' + date.toLocaleString() + '</span>');
        }

        if (config.title) {
            span.attr('title', date.toLocaleString());
        }

        // Backwards compatibility methods
        if (typeof date.toDate === 'function') {
            node.gmttime = date.toDate();
        }

        node.format = function() {
            return momentLoader.processSpan(this);
        };

        node.getDate = function() {
            return moment($(this).text()).toDate();
        };
    },
};

// add jquery plugin, compatible with datetime.js
$.fn.dateTime = function(forceUpdate) {
    return this.each(function() {
        if (forceUpdate) {
            this.gmttime = false;
        }
        momentLoader.processSpan(this);
    });
};

export default moment;



// WEBPACK FOOTER //
// ./src/web/js/app/modules/datetime.js